// Shared by world.ts and levels.ts
import type { Vec } from '../../core/types';

export const K = 'moles';
export const DEG = Math.PI / 180;
export const P = 15;                                   // ball radius

/** What hangs on one end of a hoist rope */
export type EndType = 'lift' | 'bucket' | 'cart' | 'gate' | 'sack';

/** One end of a hoist rope (level data). Fields not used by a type are ignored. */
export interface HoistEnd {
  type: EndType;
  x: number;
  y: number;
  /** Width (lift, bucket, cart) */
  w?: number;
  /** Own mass (otherwise BASE in world.ts); for 'sack' also its size */
  m?: number;
  /** Lift: side the door opens to (1 = right, -1 = left) */
  exit?: number;
  /** Lift: height of the back wall (a low back wall lets the ball roll in from behind; no top frame then) */
  back?: number;
  /** Lift: coal on the roof (looks heavy) */
  coal?: boolean;
  /** Gate: height */
  h?: number;
  /** Cart: end of the track */
  tx?: number;
  ty?: number;
  /** Cart: tips over at the end of the track */
  tip?: boolean;
  /** Cart: tip angle in degrees (default 55) */
  tipA?: number;
  /** Cart: false = stays tipped */
  tipBack?: boolean;
  /** Cart: where the rope is tied (local) */
  hook?: Vec;
}

/** A hoist: a rope over one or two wheels with an end on each side (level data, no x/y of its own) */
export interface HoistData {
  wheels?: Vec[];
  /** Single wheel (alternative to wheels) */
  wx?: number;
  wy?: number;
  A?: HoistEnd;
  B?: HoistEnd;
  /** Travel limits of the rope */
  min?: number;
  max?: number;
  /** Friction: the rope does not move until the imbalance is larger than this */
  fric?: number;
  damp?: number;
  vmax?: number;
  /** Brake: held until the ball has been in the lift for a moment */
  hold?: boolean;
}
